import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import * as PIXI from "pixi.js";
import { TweenConstants } from "../constant/TweenConstants";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractSummaryProperties.ts
 */
export class AbstractSummaryProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.titleFieldProperties.equals(other.titleFieldProperties) &&
            this.cellPanelProperties.equals(other.cellPanelProperties) &&
            this.slingoCellProperties.equals(other.slingoCellProperties) &&
            this.jokerCellProperties.equals(other.jokerCellProperties) &&
            this.symbolWinCellProperties.equals(other.symbolWinCellProperties) &&
            this.winAmountBackgroundProperties.equals(other.winAmountBackgroundProperties) &&
            this.winAmountFieldProperties.equals(other.winAmountFieldProperties) &&
            (this.updateFieldInterval === other.updateFieldInterval) &&
            (this.dialogCompleteInterval === other.dialogCompleteInterval) &&
            (this.cellTweenInterval === other.cellTweenInterval) &&
            (this.cellTweenDelay === other.cellTweenDelay) &&
            this.fullHouseBackgroundProperties.equals(other.fullHouseBackgroundProperties) &&
            this.bigWinBackgroundProperties.equals(other.bigWinBackgroundProperties);
    }
    setDefaultValues() {
        this.position = new PIXI.Point(0, 0);
        this.backgroundProperties = new SpriteProperties(SlingoStyle.GAME_SUMMARY, SlingoStyle.MODULE);
        this.fullHouseBackgroundProperties = new SpriteProperties(SlingoStyle.GAME_SUMMARY_FULL_HOUSE, SlingoStyle.MODULE);
        this.bigWinBackgroundProperties = new SpriteProperties(SlingoStyle.GAME_SUMMARY_BIG_WIN, SlingoStyle.MODULE);
        this.titleFieldProperties = new TextFieldProperties(FontStyle.GAME_SUMMARY_TITLE, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.winAmountBackgroundProperties = new SpriteProperties(SlingoStyle.GAME_SUMMARY_WIN_BACKGROUND, SlingoStyle.MODULE);
        this.winAmountFieldProperties = new TextFieldProperties(FontStyle.GAME_SUMMARY_WIN, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.updateFieldInterval = 250;
        this.cellTweenInterval = 1.5;
        this.cellTweenDelay = 0.5;
        this.dialogCompleteInterval = TweenConstants.GAME_SUMMARY_DURATION;
    }
}
//# sourceMappingURL=AbstractSummaryProperties.js.map